import { Link } from "react-router-dom";
import Note from "../model/Note";
import moment from "moment";

type Params = {
    notes: Note[];
}

const NotesByRow = ({notes}: Params) => {
    const toggleFavorites = (noteId: number, favorites: boolean) => {
        return false;
        // NotesApi.setNoteFavorites(noteId, favorites)
        //     .then(() => {
        //         setNote({...note, favorites});
        //     })
    }
    
    return <>
        <div className="notes-list">
        {notes.map(note => {
                return <div className="note" key={'notes-list-item-' + note.id}>
                    <div className="favorites" onClick={() => toggleFavorites(note.id!, !note.favorites)}>
                        {note.favorites ? <i className="fa-solid fa-star"></i> : <i className="fa-regular fa-star"></i>}
                    </div>
                    <div className="w-100">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <Link to={"/notes/"+note.id}>
                                    {note.title}
                                </Link>
                            </div>
                            <div className="col-6 col-md-4">
                                {note.noteCategory ? note.noteCategory.title : ""}
                            </div>
                            <div className="col-6 col-md-2 text-end">
                                {moment(note.updatedAt).format('DD MMM YYYY HH.mm')}
                            </div>
                        </div>                            
                    </div>
                </div>                
        })} 
        </div>
    </>
}

export default NotesByRow